module.exports = __webpack_public_path__ + "47c1589827ff05653d0f741aea08c5a7.jpg";